// extracted by mini-css-extract-plugin
module.exports = {"safetyFee":"i2t5Q73cQHAcwTQvfgRS5w=="};